import { IResult, IRouteParam } from "../types";
import { getNotSubmitRevisionInformation } from "../utils";

const solveReturnHighlight = async (props: IRouteParam): Promise<IResult> => {
  const { currfileStepData, prevfileStepData } = props;

  const allHistorySavedInIds = currfileStepData.stepHistoryList.map((i) => i.procedureSaveInCategoryID);
  const isChangeProcedureSavedIn = new Set([...allHistorySavedInIds, currfileStepData.procedureSaveInCategoryID]).size > 1 || currfileStepData.isChangeProcedureSavedIn;
  const allHistoryPaths = currfileStepData.stepHistoryList.map((i) => i.clientServerPath);
  const isChangeClientServerPath = new Set([...allHistoryPaths, currfileStepData.clientServerPath]).size > 1 || currfileStepData.isChangeClientServerPath;

  return {
    RevisionInformation: getNotSubmitRevisionInformation(props),
    ProcedureFiles: {
      ProcedureSavedIn: false,
      SavedInStatus:
        isChangeProcedureSavedIn && (prevfileStepData.procedureSaveInCategoryStatusID !== currfileStepData.procedureSaveInCategoryStatusID || !!currfileStepData.procedureSaveInCategoryReturnReason),
      ClientServerPath: false,
      ServerPathStatus: isChangeClientServerPath && (prevfileStepData.clientServerPathStatusID !== currfileStepData.clientServerPathStatusID || !!currfileStepData.clientServerPathReturnReason),
      LevelCChange: currfileStepData.isChangeLevelC !== prevfileStepData.isChangeLevelC,
      FileNameList: currfileStepData.procedureFiles
        .filter((curr) => {
          const prevFile = prevfileStepData.procedureFiles.find((prev: any) => prev.fileID === (curr.oldFileID ?? curr.fileID));
          if (!prevFile) return true;

          return prevFile.dataStatusID !== curr.dataStatusID || (prevFile.isReviewed && curr.returnReason) || (prevFile.returnReason !== curr.returnReason && curr.returnReason);
        })
        .map((i) => `file-${i.fileID}`),
    },
  };
};

export default solveReturnHighlight;
